export function logInProduction(...msg: any[]) {
    // This function is excluded from rollup plugin 'strip' >> logs visible in Logrocket
    console.log(...msg)
}